import TransactionListItemDesktop from "components/atoms/TransactionListItemDesktop";
import { useBreakpoint } from "hooks/useBreakpoint";
import TransactionListItemMobile from "components/atoms/TransactionListItemMobile";
import { TransactionType } from "../../../types/Transaction";

import "./styles.sass";

export interface TransactionListInterface {
  list: TransactionType[];
}

const TransactionList: React.FC<TransactionListInterface> = ({ list }) => {
  const { isDesktop } = useBreakpoint();
  return (
    <div className="TransactionList">
      {list.map((item) => (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
          {isDesktop ? (
            <TransactionListItemDesktop key={item.id} transaction={item} />
          ) : (
            <TransactionListItemMobile key={item.id} transaction={item} />
          )}
        </>
      ))}
    </div>
  );
};

export default TransactionList;
